import { phpInstance } from "@/plugins/axios";

const institutionService = {};

institutionService.universityApplication = obj => {
    return phpInstance.post(`/institutionRequest`, obj);
};

export default institutionService;